import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { METHODS, euro } from "@/lib/accounting";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const PaymentDialog = ({ target, onClose, onDone }) => {
  const [f, setF] = useState({});
  useEffect(() => {
    if (target) setF({ date: new Date().toISOString().slice(0, 10), amount: Math.round((target.inst.amount - target.inst.paid) * 100) / 100, method: target.inv.payment_method || "MP05", note: "" });
  }, [target]);
  if (!target) return null;
  const save = async () => {
    try {
      await api.post(`/accounting/invoices/${target.inv.id}/payments`, { ...f, amount: Number(f.amount), installment_id: target.inst.id });
      toast.success("Movimento registrato");
      onDone();
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const out = target.inv.direction === "OUT";
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="payment-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">{out ? "Registra incasso" : "Registra pagamento"}</DialogTitle></DialogHeader>
        <p className="text-sm">{target.inv.party_name} · fattura {target.inv.number} · residuo {euro(target.inst.amount - target.inst.paid)}</p>
        <div className="grid gap-3 sm:grid-cols-2">
          <div><Label className="micro-label">Data</Label><Input type="date" value={f.date || ""} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="payment-date" /></div>
          <div><Label className="micro-label">Importo</Label><Input type="number" step="0.01" value={f.amount ?? ""} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid="payment-amount" /></div>
          <div><Label className="micro-label">Modalità</Label>
            <select className="h-10 w-full border bg-white px-2 text-sm" value={f.method} onChange={(e) => setF({ ...f, method: e.target.value })} data-testid="payment-method">{Object.entries(METHODS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></div>
          <div><Label className="micro-label">Nota</Label><Input value={f.note || ""} onChange={(e) => setF({ ...f, note: e.target.value })} data-testid="payment-note" /></div>
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose}>Annulla</Button><Button onClick={save} data-testid="payment-save-button">Registra</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
